// External
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'

// App HOC Container
import App from './App';

// Redux Store
import store from './store'

// Render
ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

